import { ActionDef } from './ActionDef';

export const getFormState = () => {
    return {
    type:ActionDef.GET_FORM_STATE
    }
}


export const updateFormState = (payload) => {
    return {
        type: ActionDef.UPDATE_FORM_STATE,
        payload: payload
    };
}
export const updateErrorState = (data) => {
    return {
        type: "UPDATE_ERROR_STATE",
        payload: data
    };
};
export const updateRemoveErrorState = (data) => {
    return {
        type: "UPDATE_REMOVE_ERROR_STATE",
        payload: data
    };
};

export const updateFormStateContext = (payload) => {
    return {
        type: "updateFormStateContext",
        payload: payload
    };
}

export const updateRouteJourneySelectionPage=(payload) =>{
    return {
        type:ActionDef.SET_SELECTION_PAGE,
        payload:payload
    }
}

export const updateTabActiveIndex = (data) => {
    return{
        type:"updateTabActiveIndex",
        payload:data
    }
}

export const reset = (data) => {
    return{
        type:"RESET",
        payload:data
    }
}

export const setFormState1 =(initialState) =>{
    return {
        type:ActionDef.SET_FORM_STATE,
        payload:initialState
    }
}

export const setGeneralData =(initialState) =>{
    return {
        type:ActionDef.SET_GENERAL_DATA,
        payload:initialState
    }
}

export const elementFromFormState = (elementId) => {
    return {
        type: ActionDef.ELEMENT_FROM_FORMSTATE,
        payload:elementId
    }
}

export const addContexts = (data) => {
    return{
        type:"ADDCONTEXTS",
        payload:data
    }
}

export const updateContexts = (data) => {
    return{
        type:"UPDATECONTEXTS",
        payload:data
    }
}

export const updateGridContexts = (data) => {
    return {
        type: "UPDATE_GRID_CONTEXTS",
        payload: data
    }
}

export const updateAdvFormData = (data) => {
    return {
        type: "UPDATE_ADV_DATA",
        payload: data
    }
}

export const updateStore = (data) => {
    return{
        type:"updateStore",
        payload:data
    }
}

export const updateMarvinContexts = (data) => {
    return {
        type: "UPDATE_MARVIN_CONTEXTS",
        payload: data
    }
}

export const updateContainerInfo = (data) => {
    return{
        type:"CONTAINERINFO",
        payload:data
    }
}

export const updateFormStateWithoutRender = (data) => {
    return{
        type:"updateFormStateWithoutRender",
        payload:data
    }
}

export const updateFormStateWithRender = (data) => {
    return{
        type:"updateFormStateWithRender",
        payload:data
    }
}

export const updateFormStateContextWithoutRender = (data) => {
    return{
        type:"updateFormStateContextWithoutRender",
        payload:data
    }
}

export const updatesubFormMetaDataWithoutRender = (data) => {
    return{
        type:"updatesubFormMetaDataWithoutRender",
        payload:data
    }
}

export const removeSubFormMetaDataWithoutRender = (data) => {
    return{
        type:"removeSubFormMetaDataWithoutRender",
        payload:data
    }
}

export const renderSection = (data) => {
    return{
        type:"renderSection",
        payload:data
    }
}

export const renderAdvListView = (data) => {
    return{
        type:"renderAdvListView",
        payload:data
    }
}

export const updateStateInRedux = (data) => {
    return{
        type:"updateStateInRedux",
        payload:data
    }
}

export const updateRenderElement = (data) => {
    return{
        type:"UPDATE_RENDER_ELEMENT",
        payload:data
    }
}

export const deleteRenderElement = (data) => {
    return{
        type:"DELETE_RENDER_ELEMENT",
        payload:data
    }
}

export const setAppScreenshotSavedDetails = (detailsArr) => {
    return{
        type:ActionDef.SET_APP_SCREENSHOT_SAVED_FLAG,
        payload:detailsArr
    }
}

export const setMap = (tableId, newData) => ({
    type: ActionDef.SET_MAP,
    payload: { tableId, newData },
  });
  
  export const clearMap = () => ({
    type: ActionDef.CLEAR_MAP,
  });

export const updateContextsStates = (payload) => {
    return {
        type: ActionDef.Update_Contexts_States,
        payload: payload
    }
}
export const updateCompleteState = (payload) => {
    return {
        type: ActionDef.Update_State,
        payload: payload
    }
}